import React, { useMemo } from "react";
import getOptionType from "./getOptionType";
import SwatchList from "./swatchList";
import TileList from "./tileList";
import classes from "./option.module.css";
import { useOption } from "../../Pregrine/ProductOptions/useOption";

const getItemKey = ({ value_index }) => value_index;

const getListComponent = (attribute_code, values) => {
  const optionType = getOptionType({ attribute_code, values });

  return optionType != "swatch" ? SwatchList : TileList;
};

const Option = (props) => {
  const {
    enabled,
    availableOptions,
    attribute_code,
    attribute_id,
    label,
    onSelectionChange,
    selectedValue,
    values,
  } = props;

  const talonProps = useOption({
    attribute_id,
    label,
    onSelectionChange,
    selectedValue,
    values,
  });

  const { handleSelectionChange, initialSelection } = talonProps;

  const ValueList = useMemo(
    () => getListComponent(attribute_code, values),
    [attribute_code, values]
  );
  
  return (
    <div
      className={`${
        attribute_code != "color" ? classes.root : classes.swatchlist
      } ${enabled ? classes.optionEnabled : classes.optionDisabled}`}
    >
      <h2
        className={
          attribute_code != "color" ? classes.title : classes.swatchtitle
        }
      >
        {label}
      </h2>
      <ValueList
        availableOptions={availableOptions}
        optionEnabled={enabled}
        attribute_code={attribute_code}
        getItemKey={getItemKey}
        selectedValue={initialSelection}
        items={values}
        onSelectionChange={handleSelectionChange}
      />
    </div>
  );
};

export default Option;
